import {ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {AsyncPipe} from '@angular/common';

import {UsersHeaderComponent} from '../users-header/users-header.component';
import {UsersTableComponent} from '../users-table/users-table.component';
import {TitleService} from '../../core/page/title.service';
import {GetAllUsersAction} from '../../core/store/users/users.action';
import {selectAllUsers} from '../../core/store/users/users.selector';
import {OphLoadingModule} from '../../shared/design/oph-loading/oph-loading.module';

@Component({
  selector: 'users-main',
  standalone: true,
  imports: [UsersHeaderComponent, UsersTableComponent, AsyncPipe, OphLoadingModule],
  templateUrl: './users-main.component.html',
  styleUrl: './users-main.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsersMainComponent implements OnInit, OnDestroy {
  private store$ = inject(Store);
  private titleService = inject(TitleService);

  users$ = this.store$.pipe(select(selectAllUsers));
  searchValue$ = new BehaviorSubject<string>('');
  unsubscribe$ = new Subject<void>();

  ngOnInit(): void {
    this.titleService.setPageTitle('Users');
    this.getUsersData();
  }

  ngOnDestroy(): void {
    this.searchValue$.complete();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  getUsersData(): void {
    this.store$.dispatch(new GetAllUsersAction({}));
  }
}
